module.exports = __webpack_public_path__ + "static/apple_store_badge-513fc2aab848f4ca55eeeba715fdb80c.svg";